import React from 'react';
const CTA_URL = 'https://trackrq.dailyhomewellness.com/click';
interface DebtQuestionProps {
  onAnswer: (answer: 'yes' | 'no') => void;
}
export function DebtQuestion({
  onAnswer
}: DebtQuestionProps) {
  const handleClick = (answer: 'yes' | 'no') => {
    onAnswer(answer);
    window.location.href = CTA_URL;
  };
  return <div className="w-full max-w-4xl mx-auto px-6 pt-12 pb-8" data-id="element-13">
      <h1 className="text-2xl md:text-4xl font-extrabold text-center text-gray-900 tracking-tight leading-tight" data-id="element-14">
        DO YOU HAVE MORE THAN $15,000 IN DEBT?
      </h1>

      <div className="mt-10 md:mt-14 grid grid-cols-2 gap-6 md:gap-10 max-w-3xl mx-auto" data-id="element-15">
        <a href={CTA_URL} onClick={e => {
        e.preventDefault();
        handleClick('yes');
      }} className="bg-[#4AA3D1] hover:bg-[#3D93C0] active:bg-[#3585B0] text-white text-2xl md:text-3xl font-semibold py-5 md:py-6 rounded shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-[#3D93C0] focus:ring-offset-2 text-center" data-id="element-16">
          YES
        </a>
        <a href={CTA_URL} onClick={e => {
        e.preventDefault();
        handleClick('no');
      }} className="bg-[#4AA3D1] hover:bg-[#3D93C0] active:bg-[#3585B0] text-white text-2xl md:text-3xl font-semibold py-5 md:py-6 rounded shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-[#3D93C0] focus:ring-offset-2 text-center" data-id="element-17">
          NO
        </a>
      </div>
    </div>;
}